import React from "react";
import { COURSE_COUNT } from 'constants/site-stats.const';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';

import ArrowDownIcon from 'assets/icons/arrow-down.svg';

import classes from './ContentFaq.module.scss';
import Link from "next/link";

const ContentFaq = ({ contentName }) => {

    const accordionStyle = {
        '& p': {
            fontSize: '18px',
            fontWeight: 700
        },
        '&.Mui-expanded': {
            color: '#BB3A90'
        }
    };

    return (
        <>
            <div className={`${classes['wrapper']} d-xl-block d-none`}>

                <h2>FAQs</h2>
                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>How do I enroll in the {contentName} online course?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Create a free Pharmuni account from our <Link href="/register">registration page</Link>, open this course page and click <b>“Start Learning”</b> button on top of the page. You can start learning instantly from any device.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>How do I complete the quiz and download my certificate?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Work through all lessons, then pass the short quiz with ≥ 80 %. When you pass, the <b>Get Certificate</b> button appears on top of this page—click it to download your PDF certificate, and you’ll also find it later under <b>My Certificates</b> in your dashboard.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>Is the {contentName} certificate recognized, and how long is it valid?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Pharmuni certificates are backed by ISO 9001 of our mother company, Zamann Pharma Support, and are accepted by employers worldwide. Each certificate stays valid for <b>two years</b> from its issue date. You can learn more about our certificates<a href="/pharmuni-certificate"> here</a>.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>What career benefits will I gain from {contentName}?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            To create this course, we constantly monitor the job market. The course teaches job-ready skills, boosting your credibility for pharmaceutical roles, especially in Quality Management. Add the credential to LinkedIn or your CV to stand out in recruiter searches.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>How long does {contentName} take, and can I learn at my own pace?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            All Pharmuni content is fully self-paced—study whenever it suits you. Most learners finish a module within one week, but there is <b>no deadline</b> as long as your subscription is active.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>What if I don’t pass the quiz the first time?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            No worries—you can <b>retake the quiz (and the course) as many times as you need</b> until you achieve the passing score and download your certificate.
                        </Typography>
                    </AccordionDetails>
                </Accordion>

                <Accordion className={classes['item']}>
                    <AccordionSummary
                        expandIcon={<ArrowDownIcon />}
                        sx={accordionStyle}
                    >
                        <Typography>How do I upgrade to Pharmuni Premium, and what extra perks do I get?</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Typography>
                            Log in, visit the <Link href={'/plans'}>Plans page</Link> and choose a <b>Monthly</b> or <b>Annual plan</b> in your local currency. Premium unlocks <b>{COURSE_COUNT}+ courses, ISO-9001 backed certificates, unlimited Skill-Tree access, a pharma CV & cover-letter builder, and a free 30-minute VIP career-coaching session every month.</b>
                        </Typography>
                    </AccordionDetails>
                </Accordion>
            </div>
        </>
    );
}

export default ContentFaq;